var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgImageExample(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_4549_204146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6255 48.7501C11.623 48.7501 8.06298 46.1876 6.77048 42.3726L6.68298 42.0851C6.37798 41.0751 6.25048 40.2251 6.25048 39.3751V22.3301L0.185482 42.5751C-0.594519 45.5526 1.18298 48.6401 4.16548 49.4626L42.823 59.8151C43.3055 59.9401 43.788 60.0001 44.263 60.0001C46.753 60.0001 49.028 58.3476 49.6655 55.9126L51.918 48.7501H15.6255Z",
    fill: "#B0BAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 22.5C25.2575 22.5 27.5 20.2575 27.5 17.5C27.5 14.7425 25.2575 12.5 22.5 12.5C19.7425 12.5 17.5 14.7425 17.5 17.5C17.5 20.2575 19.7425 22.5 22.5 22.5Z",
    fill: "#B0BAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.75 5H16.25C12.805 5 10 7.805 10 11.25V38.75C10 42.195 12.805 45 16.25 45H53.75C57.195 45 60 42.195 60 38.75V11.25C60 7.805 57.195 5 53.75 5ZM16.25 10H53.75C54.44 10 55 10.56 55 11.25V28.9975L47.1025 19.7825C46.265 18.8 45.0525 18.275 43.75 18.245C42.455 18.2525 41.24 18.8275 40.41 19.8225L31.125 30.9675L28.1 27.95C26.39 26.24 23.6075 26.24 21.9 27.95L15 34.8475V11.25C15 10.56 15.56 10 16.25 10Z",
    fill: "#B0BAC5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4549_204146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgImageExample);
export default __webpack_public_path__ + "static/media/svg_image_example.e00fe6deef5934de37bd0720b3850037.svg";
export { ForwardRef as ReactComponent };